import apiInstance from './api';

const activityApi = apiInstance.injectEndpoints({
  endpoints: (builder) => ({
    getActivities: builder.query({
      query: ({ page, pageSize }) => ({
        url: '/activities',
        method: 'GET',
        params: { page, itemsPerPage: pageSize },
      }),
      providesTags: ['Activities'],
    }),
    getActivitiesList: builder.query({
      query: (params) => {
        const {requestType, ...rest} = params;
        return {
          url: `/activities/lists/${requestType}`,
          method: 'GET',
          params: rest,
        }
      },
      providesTags: ['ActivitiesList'],
    }),
  }),
  overrideExisting: true,
});

export default activityApi;
